import { render, staticRenderFns } from "./device-update.vue?vue&type=template&id=2f33261c&scoped=true&"
import script from "./device-update.vue?vue&type=script&lang=js&"
export * from "./device-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33261c",
  null
  
)

export default component.exports